import {observable, computed, autorun, map} from 'mobx';


// The job type is a named configuration of a desinfection job.  In the Remote UI
// it is only used to allow selecting default job type for each location
// if the customer has more than one job type available.
class Role {
  constructor(dbrow) {
    this.id_role = dbrow.id_role;
    this.name = dbrow.name;
    this.description = dbrow.description;
    this.hidden = dbrow.hidden;
    this.sort_order = dbrow.sort_order;
  }
}

// For now this is just a blind copy of the rows from the database.
function createRoleFromDBRow(row) {
  return new Role(row);
}

// Make utility method available from Class (function)
Role.createFromDBRow=createRoleFromDBRow;

export default Role;



/** WEBPACK FOOTER **
 ** ./src/DataModel/Role.js
 **/